export { DoctorCard } from './doctor-card';
